export function stopQuagga() {
    Quagga.stop();
}
